import {createSelector} from "@reduxjs/toolkit";
import sliceState from "slices/brandSlice";
import {StateWithSlice} from "utils/stateWithSlice";

type StateWithBrand = StateWithSlice<"brand", ReturnType<typeof sliceState>>;

export const brandStateSelector = (state: StateWithBrand) => state.brand;

export const brandSelector = createSelector(brandStateSelector, ({brand}) => brand);

export const brandErrorSelector = createSelector(brandStateSelector, ({error}) => error);
